import { useLocation } from 'react-router-dom';
import { resolvePageMeta } from './pageMeta';
import { usePageSettingsStore } from '../../store/usePageSettingsStore';

/** Barre minimale d’un onglet détaché : titre de page + actions, pas de nav cabinet. */
export function StandaloneHeader() {
  const { pathname } = useLocation();
  const meta = resolvePageMeta(pathname);
  const pageActions = usePageSettingsStore((s) => s.pageActions);

  return (
    <header className="flex items-center justify-between gap-4 px-6 py-3 bg-white border-b border-neutral-200 flex-shrink-0 print:hidden">
      <h1
        className="text-lg font-semibold text-cime-text-primary truncate"
        style={{ fontFamily: 'var(--cime-font-heading)' }}
      >
        {meta?.title ?? 'CIME'}
      </h1>
      {pageActions ? <div className="flex items-center gap-2 flex-shrink-0">{pageActions}</div> : null}
    </header>
  );
}
